export default __webpack_public_path__ + "static/media/logo-PME.10b835bb.svg";